var _ = require('underscore'),
    NoteModelFactory = require('./factory/factory'),
    fvChannel = require('glRadio').channel('FV');


/**
 * Purpose is for populating the new note menu ...
 * Basically a helper class for it.
 * Now also utilized for creatable note types in Find and Redact as well.
 */

var CreatableNoteTypes = function() {

    this.printedNoteTypes = []; // note-type:model constructor hash -- what's printed on the menu
    this.numberAllowedPrintedNoteTypes = 0;

    this.allowedNoteTypes = []; // note types that are always allowed
    this.disallowedPrintedNoteType = []; // printed by not allowed note types
    this.drawableNoteTypes = []; // ( creatable drawable note types )
    this.pageNoteTypes = [];

    // State: this is updated
    this.currentDissalledPrintedNoteTypes = [];

    /* -- For Find and Redact -- */
    this.noteTypesToPrintForFindAndRedact = [];
    this.disallowedFindAndRedactNoteTypes = [];

    return this;

};



/* Create and cache the instance variables */

CreatableNoteTypes.prototype.initialize = function( vChannel, user ) {

    /* First get all DV note types to print in the menu */
    /* They can be enabled and disabled */
    var allDocNoteTypes = NoteModelFactory.creatableNotes('document');

    // Don't include flash notes if the system option is off ( pretend they don't exist )
    if ( !fvChannel.request('allowFlashNotes') ) {
        allDocNoteTypes = _.omit( allDocNoteTypes, 'FLASH_NOTE');
    }

    var allPageNoteTypes = NoteModelFactory.creatableNotes('page');

    this.printedNoteTypes = _.extend( {}, allDocNoteTypes, allPageNoteTypes );

    this.numberAllowedPrintedNoteTypes = _.keys( this.printedNoteTypes ).length;

    /* Now create a list of 'allowed' note types that will always be disabled -- from info known on load */
    /* Here we only need the keys -- maybe that changes later if we re-render instead of add/remove classes */
    this.allowedNoteTypes = [];

    var userHasCreateDocNotePerms = vChannel.request('allowCreateDocNote');
    var userHasCreatePgNotePerms = vChannel.request('allowCreatePgNote');
    var userHasCreateHighlightPerms = vChannel.request('allowCreateHighlight');

    var excludePageNotes = vChannel.request('settings').excludePageNotes();
    var docHasPages = !vChannel.request('activeDocHasNoPages');
    
    var userCanCreateDocNotes = userHasCreateDocNotePerms;

    var userCanCreatePageNotes = userHasCreatePgNotePerms && !excludePageNotes && docHasPages; // applies to all but highlight
    var userCanCreateHighlightNotes = userHasCreateHighlightPerms && !excludePageNotes && docHasPages; // this one must be checked separately

    var userHasGraphicStamps = user.hasGraphicStamps();
    var userHasTextStamps = user.hasTextStamps();

    if ( userCanCreateDocNotes ) {

        this.allowedNoteTypes = this.allowedNoteTypes.concat( _.keys(allDocNoteTypes) );
    }

    if ( userCanCreatePageNotes ) {

        this.allowedNoteTypes = this.allowedNoteTypes.concat( _.keys(allPageNoteTypes) );

        if ( !userHasGraphicStamps ) {

            this.allowedNoteTypes = _.without( this.allowedNoteTypes, 'GRAPHIC_STAMP' );
        }

        if ( !userHasTextStamps ) {
            this.allowedNoteTypes = _.without( this.allowedNoteTypes, 'GRAPHIC_TEXT_STAMP' );
        }

    }

    // Special case for highlights which now respect their own perm, but not the original
    if ( userCanCreateHighlightNotes ) {

        if ( this.allowedNoteTypes.indexOf('HIGHLIGHT_NOTE') < 0 ) {

            this.allowedNoteTypes.push( 'HIGHLIGHT_NOTE' );
        }

    } else {

        this.allowedNoteTypes = _.without( this.allowedNoteTypes, 'HIGHLIGHT_NOTE' );

    }


    this.disallowedPrintedNoteType =
        _.difference( _.keys( this.printedNoteTypes ), this.allowedNoteTypes );

    /* -- Cache some other 'groups' for disabling in updateNoteTypesToDisable fn -- */

    this.drawableNoteTypes = NoteModelFactory.creatableDrawableNoteTypes();
    this.pageNoteTypes = _.keys( allPageNoteTypes );

    /** ---- Find and Redact Cache ------  **/

    this.noteTypesToPrintForFindAndRedact = NoteModelFactory.getNoteTypesThatSupportFindAndRedact() ;
    this.disallowedFindAndRedactNoteTypes =
        _.difference( _.keys( this.noteTypesToPrintForFindAndRedact ) , this.allowedNoteTypes );

    /* -- End Find and Redact Cache ----*/

    return this;

};


_.extend( CreatableNoteTypes.prototype, {

    /*
     * Called to enable/disable menu items depending on the state of the application.
     * options: only exists if called from pageLoadError -- eg: { fromPageLoadError: 1, page: pageModelSourceOfTheError }.
     * Sources:
     * - Directly from onRender of the new note menu ( notes:updateNoteTypesToDisable )
     * - notes.outerCommands.pageImgLoadError (notes:updateNoteTypesToDisable)
     * - notesLayout.updateOnPageChange (notes:updateNoteTypesToDisable)
     * - notesLayout.updateOnViewModeChange (notes:updateNoteTypesToDisable)
     * - notes: _noteSaveSuccess, _deleteNoteSuccess (notes:updateNoteTypesToDisable); for FULL_PAGE_REDACTION
     * Now also enables/disabled the entire menu if there are none to choose from ( we used to hide it from the UI )
     * */
    updateNoteTypesToDisable: function( vChannel, options ) {

        // Always start with those that aren't ever allowed
        // ( and clone to not change them by reference )
        var typesToDisable = _.clone( this.disallowedPrintedNoteType) ;

        /**
         *  Catch if source stems from an event due to an error loading a page.
         * ( This would rarely occur in PDF mode, though in this mode drawable notes type
         *  would already have been disabled ).
         * Only disable drawable note items if the page that failed is the current page.
         * Note: page.get('loadError') will inherently be true here but isn't necessary.
         */
        if ( options && options.fromPageLoadError &&
            vChannel.request('currentPageNumber') == options.page.get('number') )
        {
            typesToDisable = typesToDisable.concat( this.drawableNoteTypes );
        }


        if ( !vChannel.request('allowCreationOfFullPageRedaction') ) {
            typesToDisable.push( 'FULL_PAGE_REDACTION' );
        }

        if ( vChannel.request('viewModeIsPdf') ) {
            typesToDisable = typesToDisable.concat( this.pageNoteTypes );
        }

        /**
         * In other modes, disable drawable notes types if the page doesn't support annotating.
         * Note: currentPageSupportsAnnotation inherently checks if the document has no pages.
         * ( But if the document has no pages, these types won't be rendered anyway ).
         * Note this will capture pages that have already been loaded in error.
         */
        if ( !vChannel.request('currentPageSupportsAnnotation') ) {
            typesToDisable = typesToDisable.concat( this.drawableNoteTypes );
        }

        // Simply logic so we don't need to worry about order of adding items and preventing dupes
        typesToDisable = _.unique( typesToDisable );

        this.currentDissalledPrintedNoteTypes = typesToDisable;

        return typesToDisable;

    },

    // Used to populate contents of the dropdown
    getPrintedNoteTypes: function() {

        return this.printedNoteTypes;

    },

    disableNewNoteMenus: function() {

        return this.numberAllowedPrintedNoteTypes == this.currentDissalledPrintedNoteTypes.length;

    },

    getPrintedNoteTypesForFindAndRedact: function() {

        return this.noteTypesToPrintForFindAndRedact;

    },

    /**
     * Could cache by cloning constructors used to print the template and then putting a disabled prop on them,
     * but this is likely not very expensive ( these are also printed );
     */
    getDisallowedFindAndRedactNoteTypes: function() {

        return this.disallowedFindAndRedactNoteTypes;
    },

    allFindAndRedactNoteTypesDisabled: function() {

        return this.disallowedFindAndRedactNoteTypes.length == _.keys( this.noteTypesToPrintForFindAndRedact).length;

    }


});



module.exports = CreatableNoteTypes;




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/creatableNoteTypes.js
 ** module id = 522
 ** module chunks = 0
 **/